import { shareListModalStyles } from "@insite/content-library/Components/ShareListModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

shareListModalStyles.cancelButton = {
    mergeCss:true,
    variant: "secondary",
    css: css`
        width: 100%;
    `,
}

shareListModalStyles.sendButton = {
    mergeCss:true,
    variant: "primary",
    css: css`
        width: 100%;
    `,
}

shareListModalStyles.shareByBillingTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
        `,
        tooltipBody:css`
            color: #FFFFFF !important;  
        `,
    },
}

shareListModalStyles.recipientEmailTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
        `,
        tooltipBody:css`
            color: #FFFFFF !important;
        `,
        tooltipContainer: css`
            margin-left: -150px;
            &::after {
                left: 150px;
            }
        `,
    },
    typographyProps: {
        weight: "normal",
    },
}

shareListModalStyles.shareByEmailTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
        `,
        tooltipBody:css`
            color: #FFFFFF !important;  
        `,
    },
}

shareListModalStyles.shareListTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
        `,
        tooltipContainer: css`
            width: 500px;
            margin-left: -400px;
            &::after {
                left: 400px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 290px;
                            margin-left: -270px;
                            &::after {
                                left: 270px;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
        tooltipBody: css`
            padding: 5px;
            color: #FFFFFF !important; 
        `,
    },
    typographyProps: {
        lineHeight: "16px",
    },
}

shareListModalStyles.shareByBillingRadio = {
    css: css`
            display:none;
            input {
                margin-left: 0;
            }
        `,
}